var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 17.5L6.32533 12.1583C6.00866 11.8417 5.83366 11.4167 5.83366 10.975V4.45C5.83366 3.375 6.70866 2.5 7.78366 2.5H14.5337C15.1253 2.5 15.667 2.80833 15.967 3.30833L18.192 8.43333C18.2837 8.64167 18.3337 8.86667 18.3337 9.1V10C18.3337 10.9167 17.5837 11.6667 16.667 11.6667H12.0837L12.8503 15.5417C12.892 15.725 12.867 15.925 12.7837 16.0917C12.592 16.4667 12.3503 16.8083 12.0503 17.1083L11.667 17.5ZM4.16699 11.6667H1.66699V2.5H4.16699C4.62533 2.5 5.00033 2.875 5.00033 3.33333V10.8333C5.00033 11.2917 4.62533 11.6667 4.16699 11.6667Z",
    fill: "#F94B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownOn);
export default __webpack_public_path__ + "static/media/ThumbsDownOn.4e0ea9ab9160e55985eea92909af03ad.svg";
export { ForwardRef as ReactComponent };